import { Directive, Input } from '@angular/core';
import type { CoreUIIconSize } from '../core-ui-icon/core-ui-icon.component';

export type CoreUIDropdownMenuItemVariant = 'default' | 'danger';

@Directive({
  selector: 'core-ui-dropdown-menu-item',
  standalone: false,
})
export class CoreUIDropdownMenuItemDirective {
  @Input({ required: true }) id = '';
  @Input({ required: true }) label = '';
  @Input({ required: true }) icon = '';
  @Input() iconSize: CoreUIIconSize = '16.6';
  @Input() variant: CoreUIDropdownMenuItemVariant = 'default';
  @Input() disabled = false;
  @Input() separatorBefore = false;
}
